(() => {
  'use strict';
  if (window.wosadoPaidAttributionLoaded) return;
  window.wosadoPaidAttributionLoaded = true;
  const storageKey = 'wosado_paid_attribution_v1';
  const maxAge = 90 * 86400000;
  const types = ['gclid', 'gbraid', 'wbraid'];
  const prefix = 'wosado_ads_';
  let lastPayload = '';
  let queue = Promise.resolve();
  const status = value => { document.documentElement.dataset.wosadoPaidAttribution = value; };
  const valid = (value, now) => value && types.includes(value.type) && /^[A-Za-z0-9._~-]{5,512}$/.test(value.id || '') && Number.isFinite(Date.parse(value.at)) && now >= Date.parse(value.at) && now - Date.parse(value.at) <= maxAge;
  const removeStored = () => { try { localStorage.removeItem(storageKey); } catch (_) {} };
  const writeAttributes = (record, allowed) => {
    const attributes = {wosado_ads_consent: allowed && record ? 'granted' : '', wosado_ads_click_at: record ? record.at : '', wosado_ads_consent_at: allowed && record ? new Date().toISOString() : ''};
    for (const type of types) attributes[prefix + type] = record && record.type === type ? record.id : '';
    const signature = JSON.stringify({...attributes, wosado_ads_consent_at: ''});
    if (signature === lastPayload) return queue;
    lastPayload = signature;
    queue = queue.catch(() => {}).then(async () => {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      const response = await fetch(root + 'cart/update.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes}), keepalive:true});
      if (!response.ok) throw new Error('cart_attribute_update_failed');
      const cart = await response.json();
      const saved = cart.attributes || {};
      for (const [key, value] of Object.entries(attributes)) if (String(saved[key] || '') !== value) throw new Error('cart_attribute_readback_failed');
      status(record && allowed ? 'stored' : 'cleared');
    }).catch(() => { lastPayload = ''; status('error'); });
    return queue;
  };
  const sync = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function' || typeof privacy.analyticsProcessingAllowed !== 'function' || typeof privacy.saleOfDataAllowed !== 'function') { status('privacy-unavailable'); return; }
    const allowed = privacy.marketingAllowed() && privacy.analyticsProcessingAllowed() && privacy.saleOfDataAllowed();
    if (!allowed) { removeStored(); status('not-allowed'); return writeAttributes(null, false); }
    const now = Date.now();
    let record = null;
    try { record = JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch (_) {}
    if (!valid(record, now)) { record = null; removeStored(); }
    const query = new URLSearchParams(window.location.search);
    const source = query.get('gclsrc');
    for (const type of types) {
      const id = query.get(type);
      if (type === 'gclid' && source && !source.split('.').includes('aw')) continue;
      if (id && /^[A-Za-z0-9._~-]{5,512}$/.test(id)) {
        if (!record || record.type !== type || record.id !== id) record = {type, id, at:new Date(now).toISOString()};
        break;
      }
    }
    if (record) {
      try { localStorage.setItem(storageKey, JSON.stringify(record)); } catch (_) {}
      return writeAttributes(record, true);
    }
    status('no-click');
    return writeAttributes(null, false);
  };
  const load = () => {
    if (window.Shopify && window.Shopify.customerPrivacy) return sync();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (error) status('privacy-unavailable'); else sync(); });
    } else status('privacy-unavailable');
  };
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', load);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load, {once:true}); else load();
})();